// Frontend mirror of the backend ValueChangeThresholdUtilities: per-field year-over-year change
// thresholds (percent) that trigger the warning + mandatory justification in the value form.
// Field keys use the backend DTO property names (PascalCase); form field names derive from them
// via toFormFieldName, same as the value-fields-visibility feature.

import { toFormFieldName } from "./valueFieldsVisibility";

export const THRESHOLD_VALUE_FIELDS = [
  "BuildingValues",
  "EquipmentValues",
  "BusinessInteruptionValues12Months",
] as const;

export type ThresholdFieldKey = (typeof THRESHOLD_VALUE_FIELDS)[number];

// Today's hardcoded limits - used whenever no configuration exists for a field.
export const DEFAULT_THRESHOLDS: Record<ThresholdFieldKey, number> = {
  BuildingValues: 10,
  EquipmentValues: 10,
  BusinessInteruptionValues12Months: 20,
};

export interface IValueChangeThresholdInfo {
  thresholds: Record<string, number>;
  isDefault: boolean;
  sourceClientId?: number | null;
  sourceLocationId?: number | null;
  sourceConfigurationSettingId?: number | null;
}

// Returns the effective threshold percentage for a form field (camelCase), falling back to the
// built-in default when no configuration is loaded or the field is missing from it.
export const getEffectiveThreshold = (
  info: IValueChangeThresholdInfo | null | undefined,
  formFieldName: string
): number => {
  const fieldKey = THRESHOLD_VALUE_FIELDS.find(
    (k) => toFormFieldName(k) === formFieldName
  );
  if (!fieldKey) return NaN;
  // dictionary keys may arrive Pascal- or camelCased depending on the serializer
  const configured =
    info?.thresholds?.[fieldKey] ??
    info?.thresholds?.[toFormFieldName(fieldKey)];
  return typeof configured === "number" && configured > 0
    ? configured
    : DEFAULT_THRESHOLDS[fieldKey];
};
